

































































































import { LayoutConfig } from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew';
import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import Vue from 'vue/types/umd';

function cloneAttributes(target: HTMLElement, source: any) {
  [...source.attributes].forEach((attr) => {
    target.setAttribute(attr.nodeName, attr.nodeValue);
  });
  target.textContent = source.textContent;
}
export default {
  components: {
    AppPicture,
    AppSvgIcon,
  },
  /// добавлять данные или параметры, в
  /// exampleCfgSet
  /// больше тут никаких пропсов не будет
  props: {
    cfg: {
      type: [
        Object as () => LayoutConfig['footer']['sections']['contacts'],
        Array,
      ],
      required: true,
    },
    data: {
      type: Object,
    },
  },

  mounted() {
    // Удалить когда главный лейаут будет по всему сайту
    this.injectCode();
  },

  methods: {
    // Удалить когда главный лейаут будет по всему сайту
    injectCode() {
      const codeWrapper = this.$refs.code;
      const code: string = this.data?.code;
      if (code) {
        const parser = new DOMParser();
        const elems = parser.parseFromString(`<div>${code}</div>`, 'text/html')
          .body.children[0].children;
        for (const el of elems) {
          const item = document.createElement(el.tagName);
          cloneAttributes(item, el);
          codeWrapper.append(item);
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/contacts/Contacts.vue